import Loadable from 'UIComponents/decorators/Loadable';
const AsyncEditCustomView = Loadable({
  loader: () => import( /* webpackChunkName: "edit-custom-view" */'find-and-filter-components/custom-views-build/public/EditCustomViewWizard'),
  // don't render a loading spinner for this because it's a UIModalPanel
  LoadingComponent: () => null
});
export default AsyncEditCustomView;